import { useCallback, useState } from "react";
import type { ReactElement } from "react";
import type { SupplierContract } from "@kundeninfo/api-client";
import { sharedAssignmentLists } from "../../KontierungFelder.js";
import { LiefervertragObjekt, useContractActions } from "../../../views/suppliers/LiefervertragObjekt.js";
import { SUPPLIER_TEXT_WEB as T } from "../../../views/suppliers/texts.js";
import { ObjektArbeitsdialog } from "../ObjektArbeitsdialog.js";
import type { InhaltProps } from "../ObjektPanelGastgeber.js";
import { ladeZustand, ticketWegAus, useObjektLaden } from "./lieferantenInhalt.js";

/**
 * DER LIEFERVERTRAG IM OBJEKTPANEL (Spec F6; Plan Aufgabe 3): dasselbe `LiefervertragObjekt` wie in Akte und Einkauf,
 * aufgeklappt (Kopfdaten, Konditionen, Fälligkeiten mit Zahlungen, Dateien). Bearbeiten, Kondition, Kündigung und Ticket
 * stapeln darüber (`useContractActions`); nach jedem Schreibweg lädt das Objekt neu und die Ebene gilt als geändert (F9).
 * Der Sprungknopf steht links unten (F11), der Ordner geht durch den Ausgang (PF3).
 */
export function LiefervertragInhalt(p: InhaltProps<"liefervertrag">): ReactElement {
  const { bezug, client, onGeaendert } = p;
  const [lists] = useState(() => sharedAssignmentLists(client));
  const [offen, setOffen] = useState(true);
  const laden = useCallback(() => client.getSupplierContract(bezug.customerId, bezug.id), [client, bezug.customerId, bezug.id]);
  const { stand, neu, runde } = useObjektLaden<SupplierContract>(laden);
  const aktionen = useContractActions({ client, lists, companies: p.companies, ...ticketWegAus(p),
    onDone: () => { onGeaendert(); neu(); } });
  const zustand = ladeZustand(stand, T);
  // Die Panels der Aktionen neben dem Objektpanel, nicht darin: sie stapeln über ihm (F5).
  return (
    <>
      <ObjektArbeitsdialog titel={bezug.label} seitlich={p.seitlich} sprung={p.sprung} zustand={zustand}
        onAbbrechen={p.onSchliessen}>
        {stand !== null && !(stand instanceof Error) && (
          <LiefervertragObjekt vertrag={stand} ort={p.akteKunde === bezug.customerId ? "akte" : "panel"} aufgeklappt={offen} onAufgeklappt={setOffen} client={client}
            lists={lists} companies={p.companies} mehrereUnternehmen={stand.companyId !== p.sitzungsUnternehmen} refresh={runde} mitTicket={aktionen.mitTicket}
            gesperrt={aktionen.offen} onAktion={(a) => aktionen.start(a, stand)}
            onGeaendert={() => { onGeaendert(); neu(); }} onDateienGeaendert={onGeaendert} />
        )}
      </ObjektArbeitsdialog>
      {aktionen.panels}
    </>
  );
}
